import { render, staticRenderFns } from "./metric-widget.vue?vue&type=template&id=1f599cac"
import script from "./metric-widget.vue?vue&type=script&lang=js"
export * from "./metric-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports